<template>
    <div class="electronicbilldetailed">
        <table class="QHtable" v-if="!loading">
            <tbody>
                <tr class="head">
                    <td colspan="6" style="font-size:18px;padding:14.5px !important;font-weight:700;text-align:center;"
                        v-if="!$isblank(row.NO) && $isblank(row.shipId)">
                        <p v-if="row.garbageTypeName == '装修垃圾'">装饰装修废弃物<span v-if="!$isblank(row.garbageName)">({{
                            row.garbageName }})</span>电子转移联单<span class="DAOCHU"
                                @click="$openLineMap(row.NO)">行车轨迹</span></p>
                        <p style="font-size:16px;font-weight:normal;padding:5px 0;">联单编号:{{ row.NO }}</p>

                        <p class="flex-center yunshuStatus" v-if="row.status == 100">
                            <span class="yunshuIcon iconfont icon-zhandianzhuangchebeifen flex-center" style=""></span>
                            <span>车辆{{ row.licensePlate }}正在装车</span>
                        </p>
                        <p class="flex-center yunshuStatus" v-if="row.status == 200">
                            <span class="yunshuIcon iconfont icon-yunshuzhong1 flex-center"></span>
                            <span>车辆{{ row.licensePlate }}正在运输</span>
                        </p>
                        <p class="flex-center yunshuStatus" v-if="row.status == 300">
                            <span class="yunshuIcon iconfont icon-xiehuo flex-center"></span>
                            <span>车辆{{ row.licensePlate }}正在卸车</span>
                        </p>
                        <p class="flex-center yunshuStatus status400" v-if="row.status == 400">
                            <span class="yunshuIcon iconfont icon-yunshuwancheng flex-center"></span>
                            <span>车辆{{ row.licensePlate }}已完成清运</span>
                        </p>

                        <p v-if="row.garbageTypeName == '建筑垃圾'">建筑工地废弃物<span v-if="!$isblank(row.garbageName)">({{
                            row.garbageName }})</span>电子转移联单<span class="DAOCHU"
                                @click="$openLineMap(row.NO)">行车轨迹</span></p>
                    </td>
                    <td colspan="6" style="font-size:18px;padding:14.5px !important;font-weight:700;text-align:center;"
                        v-if="!$isblank(row.NO) && !$isblank(row.shipId)">
                        <p v-if="row.garbageTypeName == '装修垃圾'">装饰装修废弃物<span v-if="!$isblank(row.garbageName)">({{
                            row.garbageName }})</span>电子转移联单</p>
                        <p style="font-size:16px;font-weight:normal;padding:5px 0;">联单编号:{{ row.NO }}</p>

                        <p class="flex-center yunshuStatus" v-if="row.status == 100">
                            <span class="yunshuIcon iconfont icon-zhandianzhuangchebeifen flex-center" style=""></span>
                            <span>{{ row.licensePlate }}正在装船</span>
                        </p>
                        <p class="flex-center yunshuStatus" v-if="row.status == 200">
                            <span class="yunshuIcon iconfont icon-yunshuzhong1 flex-center"></span>
                            <span>{{ row.licensePlate }}正在运输</span>
                        </p>
                        <p class="flex-center yunshuStatus" v-if="row.status == 300">
                            <span class="yunshuIcon iconfont icon-xiehuo flex-center"></span>
                            <span>{{ row.licensePlate }}正在卸船</span>
                        </p>
                        <p class="flex-center yunshuStatus status400" v-if="row.status == 400">
                            <span class="yunshuIcon iconfont icon-yunshuwancheng flex-center"></span>
                            <span>{{ row.licensePlate }}已完成清运</span>
                        </p>

                        <p v-if="row.garbageTypeName == '建筑垃圾'">建筑工地废弃物<span v-if="!$isblank(row.garbageName)">({{
                            row.garbageName }})</span>电子转移联单</p>
                    </td>
                </tr>
                <!--########################################排放信息########################################-->
                <template v-if="$isblank(row.shipId)">
                            <!--########################################排放信息########################################-->
                    <tr>
                        <td width="50px" rowspan="8" class="headA">排放信息</td>
                        <td width="140px" class="lable">工地信息</td>
                        <td>{{ row.projectName }}</td>
                    </tr>
                    <tr>
                        <td class="lable">清运地址</td>
                        <td>{{ row.qingYunStartAddressFull }}
                        </td>
                    </tr>
                    <tr>
                        <td class="lable">垃圾类型</td>
                        <td>{{ row.garbageTypeName }}<span v-if="!$isblank(row.garbageName)">({{ row.garbageName
                                }})</span></td>
                    </tr>
                    <tr>
                        <td class="lable">联系电话</td>
                        <td v-if="!$isblank(row.qingYunStartContactTel)">{{ row.qingYunStartContactName }} {{
                            row.qingYunStartContactTel }}</td>
                        <td v-else>零散排放小量排放,客户不愿意提供电话</td>
                    </tr>
                    <tr>
                        <td class="lable">服务时间</td>
                        <td>{{ $timeFmt(row.emissionTime, "YYYY-MM-DD HH:mm") }}</td>
                    </tr>
                    <tr>
                        <td class="lable">运输车次</td>
                        <td>{{ row.carNumber }}车</td>
                    </tr>
                    <tr>
                        <td class="lable">运输方数</td>
                        <td>{{ row.garbageNumber }}m³</td>
                    </tr>
                    <tr>
                        <td class="lable">出场照片</td>
                        <td>
                            <QHImgList :list="row.waste_img"></QHImgList>
                            <QHImgList :list="row.qingyunhouImg"></QHImgList>
                            <QHImgList :list="row.qingyunqianImg"></QHImgList>
                            <QHImgList :list="row.qingYunStartCarImg"></QHImgList>
                            <QHImgList :list="row.qingYunStartPingZhengImg"></QHImgList>
                        </td>
                    </tr>
                    <!--########################################运输信息########################################-->
                    <tr class="contentB" >
                        <td rowspan="9" class="headA">运输信息</td>
                        <td class="lable">单位名称</td>
                        <td>{{ row.orgNameYunshu }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">单位地址</td>
                        <td>{{ row.orgAddressYunshu }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">司机姓名</td>
                        <td>{{ row.driverName }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">司机电话</td>
                        <td>{{ row.driverTel }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">运输工具</td>
                        <td>{{ row.carName }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">车牌号码</td>
                        <td>{{ row.licensePlate }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">车载容量</td>
                        <td>{{ row.carCapacity }}m³</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">清运起始地址</td>
                        <td>{{ row.qingYunStartAddressFull }}
                        </td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">清运目的地址</td>
                        <td>{{ row.qingYunEndAddressFull }}
                        </td>
                    </tr>
                    </template>
                    <template v-if="!$isblank(row.shipId)">
                            <!--########################################排放信息########################################-->
                    <tr>
                        <td width="50px" rowspan="11" class="headA">排放信息</td>
                        <td width="140px" class="lable">排放单位</td>
                        <td>{{ row.orgPaifang.name }}</td>
                    </tr>
                    <tr>
                        <td class="lable">单位联系</td>
                        <td>{{ row.orgPaifang.contactName }}{{ row.orgPaifang.contactTel }}
                        </td>
                    </tr>
                    <tr>
                        <td class="lable">单位地址</td>
                        <td>{{ row.orgPaifang.addressDetailed }}
                        </td>
                    </tr>
                    
                    <tr>
                        <td class="lable">工地信息</td>
                        <td>{{ row.projectName }}
                        </td>
                    </tr>
                    <tr>
                        <td class="lable">清运地址</td>
                        <td>{{ row.qingYunStartAddressFull }}
                        </td>
                    </tr>
                    <tr>
                        <td class="lable">垃圾类型</td>
                        <td>{{ row.garbageTypeName }}<span v-if="!$isblank(row.garbageName)">({{ row.garbageName
                                }})</span></td>
                    </tr>
                    <tr>
                        <td class="lable">联系电话</td>
                        <td v-if="!$isblank(row.qingYunStartContactTel)">{{ row.qingYunStartContactName }} {{
                            row.qingYunStartContactTel }}</td>
                        <td v-else>零散排放小量排放,客户不愿意提供电话</td>
                    </tr>
                    <tr>
                        <td class="lable">服务时间</td>
                        <td>{{ $timeFmt(row.emissionTime, "YYYY-MM-DD HH:mm") }}</td>
                    </tr>
                    <tr>
                        <td class="lable">运输车次</td>
                        <td>{{ row.carNumber }}车</td>
                    </tr>
                    <tr>
                        <td class="lable">运输方数</td>
                        <td>{{ row.garbageNumber }}m³</td>
                    </tr>
                    <tr>
                        <td class="lable">出场照片</td>
                        <td>
                            <QHImgList :list="row.waste_img"></QHImgList>
                            <QHImgList :list="row.qingyunhouImg"></QHImgList>
                            <QHImgList :list="row.qingyunqianImg"></QHImgList>
                            <QHImgList :list="row.qingYunStartCarImg"></QHImgList>
                            <QHImgList :list="row.ruchangcarImg"></QHImgList>
                            <QHImgList :list="row.qingYunStartPingZhengImg"></QHImgList>
                        </td>
                    </tr>
                    <!--########################################运输信息########################################-->
                    <tr class="contentB" >
                        <td rowspan="7" class="headA">船舶信息</td>
                        <td class="lable">船舶名称</td>
                        <td>{{ row.ship.name }}{{ row.ship.shipCode }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">船舶规格</td>
                        <td>载量{{row.ship.capacity}}<br>
                        长{{row.ship.totalLength}}米,宽{{row.ship.width}}米,型深{{row.ship.depth}}米
                        </td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">船检登记号</td>
                        <td>{{ row.ship.inspectionRegistrationNumber }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">有效期至</td>
                        <td>{{ $timeFmt(row.ship.validityPeriod, "YYYY-MM-DD HH:mm") }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">所有单位</td>
                        <td>{{ row.ship.owner }}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">经营单位</td>
                        <td>{{row.ship.operator}} {{row.ship.phoneNumber}}</td>
                    </tr>
                    <tr class="contentB">
                        <td class="lable">许可证号</td>
                        <td>{{row.ship.licenseNumber}}</td>
                    </tr>
                    </template>
                    <!--########################################处置信息########################################-->
                    <template v-if="!$isblank(row.orgNameJieshou)">
                        <tr>
                            <td rowspan="13" class="headA none">处置信息</td>
                            <td class="lable">单位名称</td>
                            <td>{{ row.orgNameJieshou }}</td>
                        </tr>
                        <tr>
                            <td class="lable">单位地址</td>
                            <td class="lable">{{ row.qingYunEndAddressFull }}
                            </td>
                        </tr>
                        <tr>
                            <td class="lable">电子围栏</td>
                            <td>{{ row.dianziweilanStatusName }}</td>
                        </tr>
                        <tr>
                            <td class="lable">垃圾类型</td>
                            <td>{{ row.garbageTypeName }}<span v-if="!$isblank(row.garbageName)">({{ row.garbageName
                                    }})</span></td>
                        </tr>
                        <tr>
                            <td class="lable">处置车次</td>
                            <td>{{ row.carNumber }}车</td>
                        </tr>
                        <tr>
                            <td class="lable">处置方数</td>
                            <td>{{ row.garbageNumber }}m³</td>
                        </tr>
                        <tr>
                            <td class="lable">接收时间</td>
                            <td>{{ $timeFmt(row.endTime, "YYYY-MM-DD HH:mm") }}</td>
                        </tr>
                        <tr>
                            <td class="lable">处置方式</td>
                            <td>{{ row.chuzhiWay }}</td>
                        </tr>
                        <tr>
                            <td class="lable">接收意见</td>
                            <td>实际接收与联单信息一致</td>
                        </tr>
                        <tr>
                            <td class="lable">送达凭证</td>
                            <td>
                                <QHImgList :list="row.ruchangcarImg"></QHImgList>
                                <QHImgList :list="row.qingYunEndPingZhengImg"></QHImgList>
                            </td>
                        </tr>
                    </template>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            row: {},
        }
    },
    mounted() {
        const urlParams = new URLSearchParams(window.location.search);
        const NO = urlParams.get('NO');
        if (!NO) {
            this.$msg('参数错误', 'error');
            return false;
        };
        this.getElectronicbillDetailed(NO);
    },

    methods: {
        // +----------------------------------------------------------------------
        // | 详情
        // +----------------------------------------------------------------------
        getElectronicbillDetailed(NO) {
            this.loading = true;
            var parameter = { NO: NO };
            this.$loading(true);
            this.$api.getElectronicbillDetailed(parameter).then((res) => {
                this.loading = false;
                this.$loading(false);
                if (res.code == 0) {
                    this.row = res.data;
                } else {
                    this.$msg(res.msg, "error");
                };
            });
        },
    }
}
</script>
<style>
.electronicbilldetailed {
    max-width: 210mm;
    margin: 0 auto;
    display: block;
}

.electronicbilldetailed td {
    color: #333;
    padding: 6px 10px !important;
}

.electronicbilldetailed .headA {
    text-align: center;
    color: #fff !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    background: #3975C6;
    position: relative;
}


.electronicbilldetailed .contentB {
    background: #F9F9F9;
}

.QHtable td {
    border-color: #eee;
}

html,
body {
    min-width: 0;
    min-height: 0;
    height: auto !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
}

.DAOCHU {
    color: #3975C6;
    margin-left: 5px;
    cursor: pointer;
}

.yunshuIcon {
    font-size: 22px;
    font-weight: normal;
    margin-right: 5px;
}

.yunshuStatus span {
    display: inline-block;
    line-height: 22px;
    padding: 5px 0;
    color: #ff9900;
}

.yunshuStatus.status400 span {
    color: #19be6b !important;
}
</style>